import * as Yup from "yup";


export const superAdminSchema = Yup.object({
    email: Yup.string().required(" Enter User Name"),
    password: Yup.string().required(" Enter Your Password"),
});